import { type RequestableApproverOption } from '@webapp/modules/expense/entities/RequestableApproverOption'
import { useQueryRequestableApprovers } from '../../models'

interface UseGetRequestableApproversPresenterParams {
  department: number
  accountCodeIds: number[]
  amount: number
  baseContentTypeId: number
}

interface UseGetRequestableApproversPresenterReturn {
  data: {
    approverOptions: RequestableApproverOption[]
    autoSelectedApproverId: Nullable<number>
  }
  states: {
    isLoading: boolean
  }
}

export const useGetRequestableApproversPresenter = ({
  department,
  accountCodeIds,
  amount,
  baseContentTypeId,
}: UseGetRequestableApproversPresenterParams): UseGetRequestableApproversPresenterReturn => {
  const { data, isLoading } = useQueryRequestableApprovers({
    department,
    accountCodeIds,
    amount,
    baseContentTypeId,
    customFields: [],
  })

  const autoSelectedApproverId = data.length === 1 ? data[0].id : null

  return {
    data: {
      approverOptions: data,
      autoSelectedApproverId,
    },
    states: {
      isLoading,
    },
  }
}
